module.exports = __webpack_public_path__ + "img/video_thumb_da.a39a2d33.jpg";